/*
  F&NT · Créditos en la ficha (v21, 11 oct 2026)
  Agrega dentro de "Compra única" la línea "Te da $X en créditos F&NT" (3 % del precio normal).
  Solo se ve con Compra única marcada y sin descuento por volumen; con suscripción, con 2 o más
  piezas con descuento y en combos (no tienen "Forma de compra") no aparece.
  Si el producto solo no llega a $899 agrega "en pedidos desde $899."
  Complementa blocks/fnt-pdp.liquid sin tocarlo, igual que fnt-volumen.js.
  Lo carga snippets/free-shipping-bar.liquid en las fichas. Mismas reglas que el Flow
  "Crédito · abonar por compra" y snippets/fnt-creditos.liquid: si cambia el 3 %, cambiar los tres.
*/
(function () {
  if (window.__fntCredReady) return;
  window.__fntCredReady = true;

  var PCT = 0.03;
  var PAGINA = '/pages/creditos';

  function data() {
    var el = document.querySelector('[data-fnt-pdp-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function form() {
    return document.querySelector('.product-details form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function pesos(n) {
    return '$' + n.toLocaleString('es-MX');
  }

  function linea() {
    var once = document.querySelector('.fnt-pdp__plan--once');
    if (!once) return null;
    var el = once.querySelector('[data-fnt-cred]');
    if (el) return el;
    var row = once.querySelector('.fnt-pdp__plan-row');
    if (!row) return null;
    el = document.createElement('span');
    el.className = 'fnt-pdp__cred';
    el.setAttribute('data-fnt-cred', '');
    el.hidden = true;
    el.innerHTML = 'Te da <b><span data-fnt-cred-monto></span> en <a href="' + PAGINA + '">créditos F&amp;NT</a></b>' +
      '<span data-fnt-cred-min hidden> en pedidos desde <span data-fnt-cred-umbral></span>.</span>';
    row.insertAdjacentElement('afterend', el);
    return el;
  }

  function sync() {
    var d = data();
    var el = linea();
    if (!d || !el) return;
    var plans = document.querySelector('[data-fnt-plans]');
    var checked = plans && plans.querySelector('input[type="radio"]:checked');
    var once = !!checked && checked.value === 'once';
    var off = plans && plans.querySelector('[data-fnt-once-off]');
    var conDescuento = !!off && !off.hidden;
    var f = form();
    var idInput = f && f.querySelector('input[name="id"]');
    var id = idInput ? Number(idInput.value) : 0;
    var v = d.variants.filter(function (x) { return x.id === id; })[0] || d.variants[0];
    var q = document.querySelector('.product-details .product-form-buttons input[name="quantity"]');
    var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    var total = v ? v.price * qty : 0;
    var monto = Math.round(total * PCT / 100);
    var show = once && !conDescuento && monto >= 1;
    if (el.hidden === show) el.hidden = !show;
    if (!show) return;
    var m = el.querySelector('[data-fnt-cred-monto]');
    var txt = pesos(monto);
    if (m && m.textContent !== txt) m.textContent = txt;
    var min = el.querySelector('[data-fnt-cred-min]');
    var umbral = d.freeShipping || 89900;
    var falta = total < umbral;
    if (min) {
      if (min.hidden === falta) min.hidden = !falta;
      var u = min.querySelector('[data-fnt-cred-umbral]');
      var ut = pesos(Math.round(umbral / 100));
      if (u && u.textContent !== ut) u.textContent = ut;
    }
  }

  function start() {
    if (!document.querySelector('[data-fnt-pdp-data]')) return;
    var style = document.createElement('style');
    style.textContent =
      '.fnt-pdp__cred{display:block;margin:6px 0 0 30px;font-size:14px;line-height:1.4;color:#cfcfcf}' +
      '.fnt-pdp__cred[hidden]{display:none}' +
      '.fnt-pdp__cred b{font-weight:700;color:#CDB48E}' +
      '.fnt-pdp__cred a{color:inherit;text-decoration:underline;text-underline-offset:3px}';
    document.head.appendChild(style);
    document.addEventListener('change', function () { setTimeout(sync, 80); });
    document.addEventListener('click', function () { setTimeout(sync, 80); });
    setInterval(sync, 500);
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
